import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class MouseSpeedBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.collectIntervalDuration = 10000;
        this.movementHistory = [];
        this.lastIntervalRunTime = Date.now();
        this.collectInterval = null;
        this.id = BehaviorType.mousespeed;
        this.handler = () => { };
        this.init();
        this.iframeBehaviorListeners = [{ type: "mousemove", listener: this.mousemoveHandler }];
    }
    onMousemove(event) {
        this.movementHistory.push({
            x: event.clientX,
            y: event.clientY,
            time: Date.now(),
        });
    }
    init() {
        const mousemoveEvent = new Event("mousemove");
        this.mousemoveHandler = (event) => this.onMousemove(event);
        this.collectInterval = setInterval(() => {
            const { movementHistory } = this;
            const movementHistoryAmount = movementHistory.length;
            const intervalRunTime = Date.now();
            let averageSpeed = 0;
            if (movementHistoryAmount >= 2) {
                const totalTime = (movementHistory[movementHistoryAmount - 1].time - movementHistory[0].time) / 1000;
                if (totalTime > 0) {
                    let totalDistance = 0;
                    for (let i = 1; i < movementHistoryAmount; i += 1) {
                        const dx = movementHistory[i].x - movementHistory[i - 1].x;
                        const dy = movementHistory[i].y - movementHistory[i - 1].y;
                        totalDistance += Math.sqrt(dx * dx + dy * dy);
                    }
                    averageSpeed = totalDistance / totalTime;
                }
            }
            const mouseSpeedMetadata = {
                fromTime: new Date(this.lastIntervalRunTime).toISOString(),
                toTime: new Date(intervalRunTime).toISOString(),
                averageSpeed: Number(averageSpeed.toFixed(2)),
            };
            this.addLog(mousemoveEvent, this.id, mouseSpeedMetadata);
            this.movementHistory = [];
            this.lastIntervalRunTime = intervalRunTime;
        }, this.collectIntervalDuration);
    }
    start() {
        window.addEventListener("mousemove", this.mousemoveHandler);
        this.plasm.debug(`Behavior ${this.id} started`);
    }
    stop() {
        window.removeEventListener("mousemove", this.mousemoveHandler);
        if (this.collectInterval != null) {
            clearInterval(this.collectInterval);
        }
        this.plasm.debug(`Behavior ${this.id} stopped`);
    }
}
export default MouseSpeedBehavior;
